import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Tabs as MuiTabs, Tab, makeStyles } from '@material-ui/core';
import colors from '../../foundations/colors.module.scss';
import typography from '../../foundations/typography.module.scss';
const typographyStyles = {
    fontFamily: typography.fontFamilyLight,
    lineHeight: typography.lineHeightP1,
    color: colors.dark700
};
const sharedBorderStyles = {
    content: '""',
    position: 'absolute',
    bottom: 0,
    width: '100%'
};
const useTabContainerStyles = makeStyles(()=>({
        root: _object_spread({}, typographyStyles),
        flexContainer: {
            gap: 48,
            '&::after': _object_spread_props(_object_spread({}, sharedBorderStyles), {
                backgroundColor: colors.dark200,
                height: '2px'
            })
        },
        indicator: {
            backgroundColor: 'transparent'
        }
    }));
const useSingleTabStyles = makeStyles(()=>({
        root: _object_spread_props(_object_spread({}, typographyStyles), {
            textTransform: 'none',
            padding: 0,
            minWidth: 0,
            '&::after': _object_spread_props(_object_spread({}, sharedBorderStyles), {
                backgroundColor: 'transparent',
                borderTopLeftRadius: 1.5,
                borderTopRightRadius: 1.5,
                height: '4px',
                transition: 'background-color 0.2s ease 0s',
                zIndex: 1
            }),
            '&:hover:not([aria-selected=true])': {
                color: colors.dark900
            },
            overflow: 'unset',
            opacity: 1
        }),
        selected: {
            '&::after': {
                backgroundColor: colors.purple800
            }
        }
    }));
export function Tabs(_0) {
    let { className, tabs } = _0, props = _object_without_properties(_0, [
        "className",
        "tabs"
    ]);
    const tabsStyles = useTabContainerStyles();
    const tabStyles = useSingleTabStyles();
    return /*#__PURE__*/ _jsx("div", {
        className: className,
        "data-testid": props.testId,
        children: /*#__PURE__*/ _jsx(MuiTabs, _object_spread_props(_object_spread({
            classes: tabsStyles,
            "aria-label": props['aria-label']
        }, props), {
            children: tabs.map((param)=>{
                let { component, id, value, disabled, testId } = param;
                return /*#__PURE__*/ _jsx(Tab, {
                    classes: tabStyles,
                    disableRipple: true,
                    focusVisibleClassName: "focusVisible",
                    label: component,
                    value: value,
                    disabled: disabled,
                    "data-testid": testId
                }, id);
            })
        }))
    });
}
